<template>
    <!--所属店铺下拉接口-->
    <el-select :value="storeId"  :placeholder="placeholder" :clearable="clearable" :size="size"
               @visible-change="visiblechange" @change="change">
        <el-option
                v-for="item in list"
                :key="item.storeId"
                :label="item.storeName"
                :value="item.storeId">
        </el-option>
    </el-select>
</template>

<script>
    export default {
        name: "store-list",
        props: {
            size: String,
            placeholder: String,
            required: Boolean,
            clearable: Boolean,
            value: String,
        },
        model: {
            prop: 'value',
            event: 'input'
        },
        data() {
            return {
                list: [],
                storeId: ''
            }
        },
        watch: {
            value(newval, oldval) {
                this.storeId = newval;
            }
        },
        mounted() {
            this.getData();
        },
        methods: {
            getData() {
                this.$axios.post('/store/dropDownBox').then(res => {
                    this.list = res.data.list;
                    console.log(res.data.list)
                    if(this.required)
                        if (this.$root.getStorage('storeId')){
                            this.storeId = this.$root.getStorage('storeId')
                        }
                        else {
                            this.storeId = res.data.list[0].storeId;
                            this.$root.setStorage('storeId', res.data.list[0].storeId)
                        }
                    for(var i in this.list){
                        if(this.list[i].storeId==this.storeId){
                            this.$emit('getName', this.list[i].storeName);
                        }
                    }
                }).catch(err => {
                    this.$message.error(err.msg)
                })
            },
            visiblechange(isshow) {
                if (isshow) {
                    this.getData();
                }
            },
            change(value) {
                this.$emit('change', value);
                console.log(value)
                this.storeId=value;
                for(var i in this.list){
                    if(this.list[i].storeId==value){
                        this.$emit('getName', this.list[i].storeName);
                    }
                }
                this.$emit('input', value)
            }
        }
    }
</script>

<style scoped>

</style>